import { IntroductionSection } from "@/components/organisms/IntroductionSection";
import { SurveysListSection } from "@/features/surveys/components/organisms/SurveysListSection";
import { Separator } from "@/components/ui/separator";
import { useProjectStore } from "@/lib/zustand/useStore";

export function ManageProject() {
    const {project} = useProjectStore()
    return (
        <div className="flex items-stretch flex-1 gap-2">
            <IntroductionSection description={project?.challenge}/>

            <Separator orientation="vertical" />

            <SurveysListSection />
        </div>
    )
}
